<script lang="ts">
	import Navbar from '../../__components__/navbar/Navbar.component.svelte';
	import { UserService } from '../../domain-services/User.service';
	import { onMount } from 'svelte';
	import type { Picture } from '../../interfaces/Picture';
	import type { UserInfo } from '../../interfaces/UserInfo';
	import type { MyGoogleUserData } from '../../interfaces/MyGoogleUserData';
	import LanguageSwitcher from './_components_/language-switcher/LanguageSwitcher.component.svelte';
	import DiwoLogo from './_components_/diwo-logo/DiwoLogo.component.svelte';
	import ThemeSwitcher from './_components_/theme-switcher/ThemeSwitcher.component.svelte';
	import Questions from './_components_/questions/Questions.component.svelte';
	import AdminAccess from './_components_/admin-access/AdminAccess.component.svelte';
	import BannerNotification from './_components_/banner-notification/BannerNotification.component.svelte';
	import UserRoles from './_components_/user-roles/UserRoles.component.svelte';

	const userSharedMailboxService = new UserService();

	let profilePicture: Picture = $derived({
		src: googleUser?.thumbnailPhotoUrl,
		title: googleUser?.name?.fullName,
		alt: googleUser?.name?.fullName
	});
	let googleUser: MyGoogleUserData = $state();
	let userInfo: UserInfo;
	
	const childComponents = [Questions, ThemeSwitcher, LanguageSwitcher, AdminAccess, BannerNotification, UserRoles];

	onMount(async () => {
		getUserInfo();
		await getGoogleUser();
	});

	function getUserInfo() {
		const userInfoJson = localStorage.getItem('userInfo');
		if (userInfoJson) {
			userInfo = JSON.parse(userInfoJson);
		}
	}

	async function getGoogleUser() {
		if (userInfo.mail) {
			await userSharedMailboxService.getUser(userInfo?.mail).then((infos: MyGoogleUserData) => {
				googleUser = infos;
			});
		}
	}
</script>

<Navbar {profilePicture} {childComponents} logo={DiwoLogo} />
